export const MIXPANEL_GLOBAL_EVENT_PREFIX = "AOPS";

/**
 * Event names that should be sent to Mixpanel without the prefixes.
 */
const UNPREFIXED_EVENT_NAMES = ["$experiment_started"];

const NON_ALNUM = /[^a-z0-9]+/g;
const EDGE_UNDERSCORES = /^_|_$/g;

/**
 * Builds the Mixpanel event name using the same rules as the browser client
 * ({@link initMixpanelClient} / {@link trackEvent}).
 */
export function formatMixpanelEventName(
	event: string,
	appEventPrefix = ""
): string {
	if (UNPREFIXED_EVENT_NAMES.includes(event)) {
		return event;
	}

	// `app__surface__action` names already include the product. Do not prefix
	// them with "AOPS" or an app display name.
	if (event.includes("__")) {
		return event;
	}

	return [MIXPANEL_GLOBAL_EVENT_PREFIX, appEventPrefix, event]
		.filter(Boolean)
		.join(" ");
}

/**
 * Snake-case `event_key` from the app prefix plus event name.
 * Omits the global `AOPS` prefix; `app` already identifies the site.
 */
export function formatMixpanelEventKey(
	event: string,
	appEventPrefix = ""
): string {
	return [appEventPrefix, event]
		.filter(Boolean)
		.join(" ")
		.toLowerCase()
		.replace(NON_ALNUM, "_")
		.replace(EDGE_UNDERSCORES, "");
}
